<accordion>
  <accordion-panel [opened]="false">
    <div panel-header>Add / Edit Categories</div>
    <form [formGroup]="categoryForm" class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell large-12 bold italic">
          Select 'Add New' to create a new Category
        </div>
        <div class="cell large-6">
          <label for="categorySelect" class="required">
            Select a Category
            @if (helpCategoryEditorList.length > 0) {
              <select id="categorySelect" name="categorySelect" formControlName="categorySelect" (change)="onCategoryChanged()">
                @for (cat of helpCategoryEditorList; track cat) {
                  <option [ngValue]="cat.id">
                    {{cat.name}}
                  </option>
                }
              </select>
            } @else {
              Loading Category List...
            }
          </label>
          <label for="categoryUpdatedBy">
            Last Updated By: {{helpCategory.lastUpdatedBy}}
          </label>
        </div>
        <div class="cell large-6">
          <label for="category" class="required">
            Help Category:
            <input type="text" formControlName="categoryName" />
          </label>
          <label for="categoryUpdatedDate">
            Last Updated On: {{helpCategory.lastUpdatedDate | date: 'full'}}
          </label>
        </div>
        <div class="cell form-button-group">
          <button class="button margin-right" (click)="cancelCategory()">Cancel</button>
          <button [disabled]="categoryForm.invalid" class="button" (click)="saveCategory()">Save</button>

        </div>
        <div class="cell large-12">
          <span class="red bold padding-left">{{categoryConfirmMessage}}</span>
        </div>
      </div>
    </form>
  </accordion-panel>
  <accordion-panel [opened]="true">
    <div panel-header>{{addEditTitle}}</div>
    <section>
      <h3 class="h4 bold">{{editingName}}</h3>
      <form [formGroup]="helpForm" class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell large-6">
            <label for="name" class="required">
              Help Topic Name:
              <input type="text" formControlName="name" id="name" (change)="validateHelpForm()" />
            </label>
            <label for="category" class="required">
              Help Category:
              <select id="category" formControlName="category" (change)="validateHelpForm()">
                @for (cat of helpCategories; track cat) {
                  <option [ngValue]="cat.id">
                    {{cat.name}}
                  </option>
                }
              </select>
            </label>
            <label for="updatedBy">
              Updated By:
              <input type="text" id="updatedBy" formControlName="updatedBy" />
            </label>
          </div>
          <div class="cell large-6">
            <div>
              <div class="grid-x grid-margin-x">
                <label for="url" class="cell large-9">
                  Relative URL:
                  <input type="text" id="url" formControlName="relativeUrl" />
                </label>
                <button class="button copy-btn cell large-3" (click)="copyValueToClipboard('relativeUrl')">
                  Copy
                </button>
              </div>
              <div class="grid-x grid-margin-x">
                <label for="directUrl" class="cell large-9">
                  Direct URL:
                  <input type="text" id="directUrl" formControlName="directUrl" />
                </label>
                <button class="button copy-btn cell large-3" (click)="copyValueToClipboard('directUrl')">
                  Copy
                </button>
              </div>
            </div>
            <label for="updatedDate">
              Last Updated:
              <input type="text" id="updatedDate" formControlName="updatedDate" [value]="helpForm.get('updatedDate').value | date: 'full'" />
            </label>
          </div>
          <div class="cell large-12 form-button-group text-align-center">
            <button class="button margin-right" (click)="cancel()">Cancel</button>
            <button [disabled]="helpForm.invalid" class="button" (click)="save()">Save</button>
          </div>
          <div class="cell">
            <label for="content" class="required">
              Help Topic Content:
              <textarea [froalaEditor]="editorOptions" formControlName="content" (blur)="validateHelpForm()"></textarea>
            </label>
          </div>
          <div class="cell form-button-group">
            <button class="button margin-right" (click)="cancel()">Cancel</button>
            <button [disabled]="helpForm.invalid" class="button" (click)="save()">Save</button>
          </div>
        </div>
      </form>
    </section>
  </accordion-panel>
</accordion>



